import styled from 'styled-components'
import { primaryColor } from 'assets/global'
import { FaChevronCircleRight , FaChevronCircleLeft} from "react-icons/fa";
import { NavLink } from 'react-router-dom'
import { FaBars } from "react-icons/fa"; // Importando o ícone de menu sanduíche

export const Menu = styled.div`
  position: fixed;
  top: 64px;
  left: 0;
  min-height: calc(100vh - 64px);
  height: calc(100vh - 64px);
  width: 240px;
  overflow-y: auto;
  overflow-x: visible;
  scrollbar-width: none;
  -ms-overflow-style: none;
  transition: all 0.3s ease;
  background-color: var(--yrm-chrome-bg); /* igual à barra do topo */
  border-right: 1px solid var(--yrm-chrome-borda);
  z-index: 3;
  
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  @media (max-width: 768px) {
    z-index: 999;
  }
`

export const MobileOverlay = styled.div`
  position: fixed;
  top: 64px;
  left: 0;
  width: 100vw;
  height: calc(100vh - 64px);
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`


export const MenuButtonLeft = styled(FaChevronCircleLeft)`
  position: fixed;
  transform: translateX(20px);
  top: 20px;
  left: 240px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: rgba(255,255,255,0.92);
  cursor: pointer;
  color: ${primaryColor};
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;

  @media (min-width: 768px) {
    &:hover,
    &:focus,
    &:active {
      -webkit-transform: translateX(5px);
      transform: translateX(5px);
    }
  }

  @media (max-width: 768px) {
    left: 240px;
    width: 28px;
    height: 28px;
  }
`

export const MenuButtonRight = styled(FaChevronCircleRight)`
  position: fixed;
  transform: translateX(20px);
  top: 20px;
  left: 45px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: rgba(255,255,255,0.92);
  cursor: pointer;
  color: ${primaryColor};
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;

  @media (min-width: 768px) {
    &:hover,
    &:focus,
    &:active {
      -webkit-transform: translateX(5px);
      transform: translateX(5px);
    }
  }

  @media (max-width: 768px) {
    left: 45px;
    width: 28px;
    height: 28px;
  }
`


export const MenuButtonFarBar = styled(FaBars)`
  position: fixed;
  top: 20px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  color: ${primaryColor};
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;

  @media (min-width: 430px) {
    &:hover,
    &:focus,
    &:active {
      -webkit-transform: translateX(5px);
      transform: translateX(5px);
    }
  }

  @media (max-width: 768px) {
    left: 4%;
    z-index: 4;
    width: 28px;
    height: 28px;
    top: 14px;
  }
`

export const MenuLogo = styled.div`
  max-width: ${({ $expanded }) => $expanded ? '220px' : '120px'};
  height: ${({ $expanded }) => $expanded ? '120px' : '100px'};
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #808080;
  margin: 32px auto 20px auto;
  padding-bottom: 1px;

  & img {
    width: ${({ $expanded }) => $expanded ? '88%' : '88%'};
    max-width: ${({ $expanded }) => $expanded ? '210px' : '90px'};
    min-width: ${({ $expanded }) => $expanded ? '120px' : 'unset'};
    display: block;
    margin: 0 auto;
    transition: width 0.2s, max-width 0.2s, min-width 0.2s, height 0.2s;
    @media (max-width: 768px) {
      width: 95%;
      height: 95%;
    }
  }
`


// Faixa dourada do item ativo: uma só, que desliza até o item escolhido
export const IndicadorMenu = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  border-radius: 0 4px 4px 0;
  background: var(--yrm-chrome-ativo);
  pointer-events: none;
  z-index: 1;
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1), height 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const MenuItems = styled.div`
  padding: 12px 0;
`

export const MenuLink = styled(NavLink).attrs(props => ({
  as: props.$isLogout ? 'div' : NavLink
}))`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 42px;
  margin: 0 8px 2px;
  padding: 0 12px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  & p {
    margin: 0;
    flex: 1 1 auto;
    min-width: 0;
    color: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  svg {
    flex: none;
    width: 20px;
    height: 20px;
    color: inherit;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
    color: #fff;
  }

  /* ativo: faixa à esquerda e texto em destaque, sem bloco colorido */
  &.active {
    background-color: rgba(214, 169, 58, 0.18);
    color: #fff;
    font-weight: 700;
  }
  &.active svg { color: var(--yrm-chrome-ativo); }

  /* selo de não lidas: o ícone segue a cor do item (o antd pintava de cinza) */
  .selo-menu { color: inherit; }

  &.only-icon {
    justify-content: center;
    padding: 0;
  }

  @media (max-width: 768px) {
    height: 44px;
  }
`
